// TODO: заменить при переходе на vue 3

let id: number = 1;

export function useId(prefix?: string): string {
  return `rem-${prefix ? `${prefix}-` : ''}${id++}`;
}
